import types from './actionTypes';

const initialState = {
  loading: false,
  marketingCampaigns: [],
  error: '',
};

const marketingCampaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_MARKETING_CAMPAIGN_STATE:
      return initialState;
    case types.CREATE_MARKETING_CAMPAIGN.REQUEST:
    case types.UPDATE_MARKETING_CAMPAIGN.REQUEST:
    case types.SYNC_MARKETING_CAMPAIGNS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.CREATE_MARKETING_CAMPAIGN.SUCCESS:
    case types.UPDATE_MARKETING_CAMPAIGN.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case types.SYNC_MARKETING_CAMPAIGNS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        marketingCampaigns: [...action.marketingCampaigns],
      };
    case types.CREATE_MARKETING_CAMPAIGN.FAILURE:
    case types.UPDATE_MARKETING_CAMPAIGN.FAILURE:
    case types.SYNC_MARKETING_CAMPAIGNS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default marketingCampaignReducer;
